export const layoutTypes = {
  VERTICAL: 'vertical',
};

export const layoutModeTypes = {
  LIGHTMODE: 'light',
  DARKMODE: 'dark',
};

export const leftSidebarTypes = {
  LIGHT: 'light',
  DARK: 'dark',
  GRADIENT: 'gradient',
};

export const layoutWidthTypes = {
  FLUID: 'lg',
  BOXED: 'boxed',
};

export const layoutPositionTypes = {
  FIXED: 'fixed',
  SCROLLABLE: 'scrollable',
};

export const topbarThemeTypes = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const leftsidbarSizeTypes = {
  DEFAULT: 'lg',
  SMALLICON: 'sm',
};

export const leftSidebarViewTypes = {
  DEFAULT: 'default',
  DETACHED: 'detached',
};

export const sidebarVisibilitytypes = {
  SHOW: 'show',
  HIDDEN: 'hidden',
};